"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayOut = void 0;
class ReplayOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ReplayOut.attributeTypeMap;
    }
}
exports.ReplayOut = ReplayOut;
ReplayOut.discriminator = undefined;
ReplayOut.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=ReplayOut.js.map